import React, { useState, useEffect } from "react";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import GithubIcon from "@material-ui/icons/GitHub";
import "../styles/Home.css";
import Typewriter from "../animation/typewriter.js";
import ArticleIcon from "@mui/icons-material/Article";
import resume from "../assets/Resume.pdf";

function Home() {
  const [showText, setShowText] = useState(false);
  const [paddingClass, setPaddingClass] = useState("initial-padding");

  useEffect(() => {
    if (!showText) {
      const timer = setTimeout(() => {
        setShowText(true);
        setPaddingClass("no-padding");
      }, 3000);

      // Cleanup the timer
      return () => clearTimeout(timer);
    } else {
      // Immediately show the text if the effect has already run
      setShowText(true);
    }
  }, []);

  return (
    <div className="home">
      <div className={`initial-view ${paddingClass}`}>
        <div className="headerText">
          <h3>
            <Typewriter text="Hi, my name is Kayton" delay={100} />
          </h3>
        </div>
        {showText ? (
          <div className="icons description fade-in">
            <p>
              Frontend Developer with full-stack expertise, bridging strategy
              and development to turn business needs into technical solutions.
            </p>
            <div className="icon-group">
              <a
                target="_blank"
                href="https://www.linkedin.com/in/kayton-froeschl/"
              >
                <LinkedInIcon />
              </a>
              <a
                target="_blank"
                href="https://github.com/kaytonfroeschl?tab=repositories"
              >
                <GithubIcon />
              </a>
              <a
                target="_blank"
                href={resume}
                className="download-link"
                rel="noopener noreferrer"
              >
                <ArticleIcon />
                <span class="tooltip">Download my resume!</span>
              </a>
            </div>
          </div>
        ) : null}
      </div>

      {showText ? (
        <div className="skills-container fade-in">
          <div className="navy-shape"></div>
          <div className="red-shape"></div>
          <div className="skills">
            <h1> Skills</h1>
            <ol className="list">
              <li className="item">
                <h2>- Front-End -</h2>
                <span>
                <p>React, React Native, TypeScript, JavaScript, HTML, CSS, jQuery, Bulma, Material UI, Bootstrap, Apollo Client</p>
                </span>
              </li>
              <li className="item">
                <h2>- Back-End -</h2>
                <span>
                <p>Node.js, GraphQL, Apollo Server, SQL, DynamoDB, C++, AWS (Amplify Gen 1 & 2, AppSync, IAM, Lambda, Cognito), REST APIs, JSON</p>
                </span>
              </li>
              <li className="item">
                <h2>- Tools & Platforms -</h2>
                <span><p>GitHub, Figma, Adobe AEM, Drupal 8, NPM, Vite</p> </span>
              </li>
            </ol>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default Home;
